import { OptionalFeature } from "../../../../base/domain/drawing";
import { IGridBehavior } from "./IGridBehavior";

export class GridBehavior extends OptionalFeature implements IGridBehavior {
  constructor(
    isEnable: boolean             = false,
    public divisionCount: number  = 10,
  ) {
    super(isEnable);
  }

  clone(): GridBehavior {
    return new GridBehavior(this.isEnable, this.divisionCount);
  }

  static from(source: IGridBehavior): GridBehavior {
    return new GridBehavior(source.isEnable, source.divisionCount);
  }

  static to(source: GridBehavior): IGridBehavior {
    return {
      isEnable: source.isEnable,
      divisionCount: source.divisionCount,
    };
  }
}
